// © Microsoft Corporation. All rights reserved.
import { LiteLogger } from "./LiteLogger";
/**
 * Set the logger instance.
 * @param _logger The logger instance to change to.
 */
export function setLogger(_logger) {
    logger = _logger;
}
/** Logger used by everyone. Default is LiteLogger. Please set up desired logger implementaiton with setLogger(). */
export let logger = new LiteLogger();
//# sourceMappingURL=Logger.js.map